export default {
  title: "Passionate Riichi, Ultra-Intense Showdown",
  game_title:
    "마드- 리치 마작는 3D로 구현된 고열정의 마작 플랫폼입니다. 지금 바로 리치 마작 여정을 시작하세요.",
  game_title1:
    "강력한 작사들을 이끌고 마작 토너먼트를 정복하여 최강의 팀의 영광을 손에 넣어 보세요.",
  header: {
    Menu: ["홈", "캐릭터", "팔로우"],
  },
  role_title: "캐릭터",
  rolt: [
    {
      name: "마가렛",
      desc: "순수하고 무심한 메이드고난도 댄스 도전자",
    },
    { name: "유나", desc: "활력 마작 소녀 타코야키 킬러" },
    { name: "로키라", desc: "인기 마술사 그녀의 마술 소품이 되지 않도록 조심하세요" },
    { name: "란야", desc: "미스터리 마작 도장주 특기는 비파 연주" },
    { name: "해모", desc: "은퇴한 프로게이머 사랑에 모든 것을 내던지는 그녀" },
    { name: "? ?", desc: "? ? ? ? ? ? ? ?" },
  ],
  "people": {
    "names": ["마가렛", "유나", "로키라", "란야", "해모", "키리시마 츠키","화쟈오","セリア","이비","레잉","????","????"],
    "descs": [
      "순정 삼무 메이드<br/>고난도 댄스 도전자",
      "활력 마작 소녀<br/>타코야키 킬러",
      "인기 마술사 <br/>그녀의 마술 소품이 되지 않도록 조심하세요",
      "미스터리 마작 도장주<br/>특기는 비파 연주",
      "은퇴한 프로게이머<br/>사랑에 모든 것을 내던지는 그녀",
      "상고 신사의 무녀<br/>그대와 미완의 인연을 이어가길",
      "사천 푸드 레스토랑 셰프<br/>뜨거운 두부는 급하게 먹으면 안 돼요",
      "나르시시스트 현상 수배 마녀<br/>별 5점을 주시는 걸 잊지 마세요",
      "자연계 신성한 나무의 정령<br/>목욕을 좋아하고 건강함",
      "불교계 무술의 떠오르는 스타<br/>고양이 돌보기, 차 마시기, 패 처리하기",
      "? ? ? ? ? ? ?<br/>? ? ?",
      "? ? ? ? ? ? ?<br/>? ? ?",
    ]
  },
  "footer_list": ['서비스 약관', '개인정보 보호정책']
};
